


































































































































































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import TsUpload from "@/components/upload.vue";

@Component({
  components: {
    TsUpload,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        // 保存
      }
    });
  }

  handleChange() {
    // 改变
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("enterapply/detail", {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data && res.Data !== "{}") {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }
}
